<template>
    <LayoutDefault variant="black" withoutFooter>
        <TransitionFade>
            <OrganismLoadingScreen v-if="isLoading"/>
        </TransitionFade>
        <TransitionFadeBackground>
            <LayoutAnarchive v-if="!isLoading" @plus="handlePlus" @minus="handleMinus" class="anarchive">
                <TransitionFade mode="out-in">
                    <router-view ref="anarchive"></router-view>
                </TransitionFade>
            </LayoutAnarchive>
        </TransitionFadeBackground>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault.vue";
import OrganismBottomToggle from "../components/anarchive/organisms/OrganismBottomToggle.vue";
import OrganismLoadingScreen from "../components/anarchive/organisms/OrganismLoadingScreen.vue";
import TransitionFadeBackground from "../transitions/home/TransitionFadeBackground.vue";
import TransitionFade from "../transitions/TransitionFade.vue";
import {mapActions, mapState} from "vuex";
import LayoutAnarchive from "../layouts/LayoutAnarchive.vue";
import ImageLoading from "../mixins/image-loading";

export default {
    name: "PageAnarchive",
    mixins: [ImageLoading],
    components: {
        LayoutAnarchive,
        TransitionFade,
        TransitionFadeBackground,
        OrganismLoadingScreen,
        OrganismBottomToggle,
        LayoutDefault
    },
    data() {
        return {
            isImagesLoading: true,
        }
    },
    mounted() {
        if (this.events.length === 0) {
            this.getEvents();
        }

        this.awaitImagesLoading('.anarchive').then(() => {
            setTimeout(() => {
                this.isImagesLoading = false;
            }, 2000)
        });
    },
    methods: {
        ...mapActions('event', {
            limitYear: 'getLimitYear',
            forYear: 'getForYear',
        }),

        handlePlus() {
            this.$refs.anarchive.handlePlus();
        },

        handleMinus() {
            this.$refs.anarchive.handleMinus();
        },

        getEvents() {
            this.limitYear().then(response => {
                this.forYear({startYear: response.limit_year, endYear: new Date().getFullYear()})
            })
        },
    },
    computed: {
        ...mapState('event', {
            events: 'anarchiveEvents',
        }),
        ...mapState('ui', {
            loaders: 'loaders',
        }),
        isEventsLoading() {
            return this.loaders['ANARCHIVE_EVENTS'];
        },
        isLoading() {
            return this.isEventsLoading || this.isImagesLoading;
        }
    }
}
</script>
